import { TableCell } from '@mui/material';

import { RowCellStatus } from './row-cell-status';

// ----------------------------------------------------------------------

type Props = {
  key: string;
  source: string;
  headerIndex: number;
  baseTabs: any[];
};

export function RowCellLearningSource({ key, source, headerIndex, baseTabs }: Props) {
  return (
    <TableCell key={key || headerIndex}>
      <RowCellStatus
        row={{ status: source === 'feedback' ? 'LOW_RATING' : 'SESSION_END' }}
        headCellId="status"
        value={source}
        moduleName="learning-queue"
        t={(val: string) =>
          val === 'LOW_RATING' ? 'Low Rating' : val === 'SESSION_END' ? 'Session End' : val
        }
        baseTabs={baseTabs}
      />
    </TableCell>
  );
}
